<div class="navigation">
  <a class="btn btn-default" (click)="openCreate.emit()">
    <i class="fa fa-plus"></i>
  </a>
  <material-edit-navigation></material-edit-navigation>
</div>
